import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Utgått av produksjon",
  "Spare part list": "Liste over reservedeler",
  "Download Excel": "Last ned Excel",
  "Recent search list": "Nylig søkeliste",
  "No data": "Ingen data",
  "spare part": "reservedel",
  "none": "ingen",
  "no value": "ingen verdi",
  "No results found": "Ingen resultater funnet",
  "Spare parts for": "Reservedeler til",
  "Could not load cumulated data": "Kunne ikke laste inn kumulerte data",
  "commissioning part": "igangkjøringsdel",
  "wear part": "slitasjedel",
  "Search": "Søk",
  "Tk": "Tk",
  "Spare part number": "Reservedelens nummer",
  "drawing": "tegning",
  "Products for": "Produkter for",
  "Available": "Tilgjengelig",
  "MM": "MM",
  "The entered order code is invalid": "Den angitte bestillingskoden er ugyldig",
  "Recommended": "Anbefales",
  "No data available for the entered search parameters": "Ingen data tilgjengelig for de angitte søkeparameterne",
  "Search spare parts": "Søk etter reservedeler",
  "Order code / product root / serial number": "Bestillingskode / produktrot / serienummer",
  "Characteristic": "Karakteristisk",
  "Please enter an order code": "Vennligst skriv inn en bestillingskode",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "Når det gjelder kvalitets- og sikkerhetsaspekter, anbefaler Endress+Hauser på det sterkeste at det utelukkende brukes originale Endress+Hauser-reservedeler. \nInstrumentet må kun vedlikeholdes og repareres av kvalifisert personell. \nDokumentasjonen av enheten, gjeldende standarder og lovkrav samt eventuelle sertifikater må overholdes!",
  "Maintenance advice": "Råd om vedlikehold",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "Hvilke(t) produkt(er) kan reservedelen min brukes til? Ved å fylle inn reservedelens bestillingskode (f.eks. 71002865 eller XPD0024) vises de relevante enhetene denne reservedelen kan brukes i.",
  "tool": "verktøy",
  "Production numbers": "Produksjonstall",
  "New alternative": "Nytt alternativ",
  "There are no items selected. Please use the checkboxes to make your selection": "Det er ingen elementer valgt. Vennligst bruk avkrysningsboksene for å gjøre ditt valg",
  "Service segmentation": "Segmentering av tjenester",
  "Seg": "Seg",
  "Valid": "Gyldig",
  "Pos": "Pos",
  "Value": "Verdi",
  "service segmentation 2": "Deler som krever grunnleggende kunnskap. Vellykket deltakelse i E+H-grunnopplæringen er en forutsetning.",
  "Phase out date": "Utfasingsdato",
  "service segmentation 1": "Deler som krever grunnleggende kunnskap.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Hvilke reservedeler er tilgjengelige for mitt produkt? Ved å fylle inn bestillingskoden (f.eks. FTC260-AA2A1 eller PMC51-BA21JB1CGBTDJB) eller produktidentifikasjonen (f.eks. FTC260 eller 83F50) får du frem de aktuelle reservedelene.",
  "Set filter": "Sett filter",
  "Search date": "Søkedato",
  "Group": "Gruppe",
  "Warning": "Advarsel",
  "Description": "Beskrivelse",
  "Cancel": "Avbryt",
  "service segmentation 4": "Deler for reparasjon på fabrikken. Ekspertkunnskap er obligatorisk.",
  "service segmentation 3": "Deler som krever spesialisert kunnskap. Vellykket deltakelse i E+H Advanced Training er en forutsetning.",
  "Drawing Position Number": "Tegningsposisjonsnummer",
  "Spare parts search": "Søk etter reservedeler",
  "Confirm": "Bekreft",
  "Ordercode too short": "For kort bestillingskode",
  "Product status": "Produktstatus",
  "Open": "Åpen",
  "Clear": "Klar",
  "PDF file with assembly instructions": "PDF-fil med monteringsanvisning",
  "Search products": "Søk etter produkter",
  "Export": "Eksport",
  "Production date": "Produksjonsdato",
  "Order stop": "Bestillingsstopp",
  "Calibration until": "Kalibrering til",
  "PDF file with compatibility information": "PDF-fil med informasjon om kompatibilitet",
  "Add selection to cart": "Legg til valg i handlekurven",
  "Mounting advices": "Råd om montering",
  "Recommended parts only": "Kun anbefalte deler",
  "not applicable": "ikke aktuelt",
  "accessories": "tilbehør",
  "Cumulative spare parts list": "Kumulativ reservedelsliste",
  "YYYY": "YYYY",
  "Title": "Tittel",
  "Error": "Feil",
  "Ordercode too long": "For lang bestillingskode",
  "Functions": "Funksjoner",
  "Rec": "Rec",
  "Type": "Type",
  "Spare sensor until": "Reservesensor til",
  "Spare parts until": "Reservedeler frem til",
  "Filter": "Filter",
  "Check all": "Sjekk alle",
  "Order code": "Bestillingskode",
  "Repair until": "Reparasjon til",
  "Tag": "Tag",
  "Ok": "Ok",
  "Category code": "Kategori kode",
  "Phase out": "Utfasing",
  'Compatibility advices': 'Tilleggsdokumenter',
  'Co.': 'Tillegg dok.',
} as LocalizedDictionary;
